"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreservationistCampaign = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Turmoil_1 = require("../../../turmoil/Turmoil");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const Resources_1 = require("../../../Resources");
const Card_1 = require("../../Card");
class PreservationistCampaign extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.PRESERVATIONIST_CAMPAIGN,
            metadata: {
                cardNumber: 'Y39',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.delegates(2).reds().br;
                    b.minus().tr(1).megacredits(18);
                }),
                description: 'Place 2 delegates into Reds. Lower your TR 1 step and gain 18 M€.',
            },
        });
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const party = turmoil.parties.find((p) => p.name === PartyName_1.PartyName.REDS);
        if (party === undefined)
            Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.REDS);
        return true;
    }
    play(player) {
        const game = player.game;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.REDS)) {
            turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.REDS, game, 'reserve');
            turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.REDS, game, 'reserve');
        }
        else {
            player.addResource(Resources_1.Resources.MEGACREDITS, 7, { log: true });
        }
        player.decreaseTerraformRating();
        player.addResource(Resources_1.Resources.MEGACREDITS, 18);
        return undefined;
    }
}
exports.PreservationistCampaign = PreservationistCampaign;
//# sourceMappingURL=PreservationistCampaign.js.map